import React ,{ Component, useEffect } from 'react'
import { useLazyQuery } from '@apollo/client';
import { FIND_USER } from '../../queries';

const UsernameSearchContainer = ({index, changeMember}) => {
    const findUser = useLazyQuery(FIND_USER);

    useEffect(() => {
        if (findUser[1].data?.findUserByUsername)
            changeMember(index, findUser[1].data.findUserByUsername.id);
        else if (findUser[1].data)
            changeMember(index, -1);
    }, [findUser, changeMember, index])


    return (
        <UsernameSearch findUser={findUser} index={index} changeMember={changeMember} id={findUser[1].data?.findUserByUsername?.id}/>
    )
}

class UsernameSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: ''
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;


        const up = () => {
            if (value) {
                try {
                    this.props.findUser[0]({
                        variables: {
                            username:this.state.username
                        }
                    });
                }
                catch (e){}
            }
            else this.props.changeMember(this.props.index, 0);
        }

        this.setState({
          username: value
        },up);

    }

    render() {
        const style = {
            backgroundColor: 'pink'
        }

        if (this.props.findUser[1].data?.findUserByUsername || !this.state.username)
                style.backgroundColor = 'inherit';
        return (
            <div className="form-group">
                <input
                    type="text"
                    className="form-control shadow-sm"
                    style={style}
                    placeholder={`Member ${this.props.index+2} Username`}
                    value={this.state.username}
                    onChange={this.handleInputChange}
                    />
            </div>
        )
    }
}

export default UsernameSearchContainer;
